
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/scholarships/[slug]",
      function () {
        return require("private-next-pages/scholarships/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/scholarships/[slug]"])
      });
    }
  